export enum RotatedGridBlock {
  Root = 'RotatedGrid',
}

export enum RotatedGridModifier {
  AutoWidth = 'autoWidth',
}
